export function getDescription(props) {
  return props.userProviders.length > 1
    ? props.t('m_accounts_linked')
    : props.t('m_account_linked', { account: props.userProviders[0] })
}
